"use client";
import React, { useContext, useEffect, useState,useRef } from 'react';
import clickSound from "../../../../assets/adiuo/button-click.mp3";
import svgPaths from "../../../../imports/svg-b343pn5u7l";
import { useColor } from "../../../../components/ui/ColorContext";
import imgBackground from '../../../../assets/img/NewUI_Images/background.png';
import imgLogo from '../../../../assets/img/NewUI_Images/atlantis-logo.jpeg';
import { Buttons } from "../../../../components/ui/button";
import FloatingHub from "../../../../assets/img/screens/FloatingHub.mp4";
import QuestHubVideo from "../../../../assets/img/screens/QuestHub.mp4";
import { ScoreContext } from '../GamePreview';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useParams,useNavigate } from 'react-router-dom';
import { getBackgrounds, getAssignedGame, updateLearnerDetails,getupdateLearnerDetails } from '../../../../../src/utils/gameApplication/gamePlayService';
  const NavigationArrow: React.FC<{
    direction: 'left' | 'right';
    onClick: () => void;
  }> = ({ direction, onClick }) => {
     const { primaryColor } = useColor();
    return (
      <Buttons
        variant="ghost"
        size="sm"
        onClick={onClick}
        className="h-[2.125rem] w-[3.125rem] rounded-3xl px-4 py-2 transition-all duration-200 hover:scale-110"
        style={{
          background: `linear-gradient(${
            direction === 'left' ? '275.041deg' : '90deg'
          },
          rgba(${hexToRgb(primaryColor)}, 0.6) 7.25%, rgba(${hexToRgb(
            primaryColor,
          )}, 0.15) 84.803%)`,
          border: `1px solid ${primaryColor}`,
          boxShadow: `0px 0px 15.9542px 0px rgba(${hexToRgb(
            primaryColor,
          )}, 0.3)`,
        }}
      >
        {direction === 'left' ? (
          <ChevronLeft className="!h-4 !w-4 text-white" />
        ) : (
          <ChevronRight className="!h-4 !w-4 text-white" />
        )}
      </Buttons>
    );
  };

const SkipButton = ({ onClick }: { onClick: () => void }) => {
  const { primaryColor } = useColor();

  return (
    <button
      onClick={onClick}
      //  className="absolute bottom-6 right-6 z-50 rounded-full px-5 py-2 text-sm font-semibold text-white backdrop-blur-md"
      className="fixed bottom-6 right-6 z-50 rounded-full px-5 py-2 text-sm font-semibold text-white backdrop-blur-md"
      style={{
        background: 'rgba(0,0,0,0.55)',
        border: `1px solid ${primaryColor}`,
        boxShadow: `0 0 12px ${primaryColor}`,
        marginBottom: '11rem',
        marginRight: '4rem'
      }}
    >
      Skip
    </button>
  );
};
interface GameIntroType {
  preloadedAssets: any;
  setCurrentScreenId: (id: number) => void;
  currentScreenId?: any;
  gameInfo: any;
  hasMulitLanguages: boolean;
  gameProgressData: any;
  setReplayState: any;
  setReplayIsOpen: any;
  setQuestState: any;
  gameLanguages: any;
  profileData: any;
  setProfileData: any;
  isInitialLoadScreenWelcome: boolean;
  setIsInitialLoadScreenWelcome: (value: boolean) => void;
  setShowFloatingHub:any;
  showFloatingHub:any;
  setLearnerPlayingDetails:any;
  learnerPlayList:any;
  setAssignId:any;
  AssignId:any;
  setFeedbackList:any;
  UpdateLearnerData:()=>void;
   audioObj:any;
   setAudioObj:any;
}

interface WelcomeProps {
  onNavigate?: (direction: "left" | "right") => void;
}
// Helper function to convert hex to RGB
const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return "0, 255, 187"; // fallback to default green
  const r = Number.parseInt(result[1], 16);
  const g = Number.parseInt(result[2], 16);
  const b = Number.parseInt(result[3], 16);
  return `${r}, ${g}, ${b}`;
};

const AvatarAndTitle: React.FC = () => {
  const { primaryColor } = useColor();

  return (
    <div className="box-border content-stretch flex flex-col gap-2 items-center justify-start p-0 relative shrink-0 w-full">
      <div className="bg-[#000000] box-border content-stretch flex flex-row gap-1.5 items-center justify-center p-3.5 relative rounded-full shrink-0">
        <div
          className="absolute border-[0.654px] border-solid inset-0 pointer-events-none rounded-full"
          style={{
            borderColor: "#033326",
            boxShadow: `0px 2.618px 7.853px 0px rgba(${primaryColor
              .replace("#", "")
              .match(/.{2}/g)
              ?.map((hex:any) => parseInt(hex, 16))
              .join(", ")}, 0.2)`,
          }}
        />
        <div
          className="bg-center bg-cover bg-no-repeat shrink-0 size-[6.092rem] rounded-full"
          data-name="image 99"
          style={{ backgroundImage: `url('${imgLogo}')` }}
        />
      </div>
      <p className="adjustLetterSpacing block leading-[6.438rem] whitespace-pre font-uncial-antiqua text-5xl font-normal text-center text-white tracking-[-0.008rem]">
       PROJECT ECHO
      </p>

      {/* Background effects */}
      <div className="absolute flex h-[27.69rem] items-center justify-center left-[18.514rem] mix-blend-lighten top-[-8.421rem] w-[31.188rem]">
        <div className="flex-none rotate-[33.283deg]">
          <div className="h-[15.169rem] relative w-[27.352rem]">
            <div className="absolute bottom-[-167.188%] left-[-92.72%] right-[-92.72%] top-[-167.188%]">
              <svg
                className="block size-full"
                fill="none"
                preserveAspectRatio="none"
                viewBox="0 0 1250 1055"
              >
                <g
                  filter="url(#filter0_f_70_172)"
                  id="Ellipse 7188"
                  opacity="0.1"
                  style={{ mixBlendMode: "lighten" }}
                >
                  <ellipse
                    cx="624.819"
                    cy="527.354"
                    fill={primaryColor}
                    rx="218.819"
                    ry="121.354"
                  />
                </g>
                <defs>
                  <filter
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                    height="1054.26"
                    id="filter0_f_70_172"
                    width="1249.19"
                    x="0.223328"
                    y="0.223328"
                  >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                      in="SourceGraphic"
                      in2="BackgroundImageFix"
                      mode="normal"
                      result="shape"
                    />
                    <feGaussianBlur
                      result="effect1_foregroundBlur_70_172"
                      stdDeviation="202.888"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute flex h-[27.69rem] items-center justify-center left-[-7.286rem] mix-blend-lighten top-[-5.972rem] w-[31.188rem]">
        <div className="flex-none rotate-[33.283deg]">
          <div className="h-[15.169rem] relative w-[27.352rem]">
            <div className="absolute bottom-[-167.188%] left-[-92.72%] right-[-92.72%] top-[-167.188%]">
              <svg
                className="block size-full"
                fill="none"
                preserveAspectRatio="none"
                viewBox="0 0 1250 1055"
              >
                <g
                  filter="url(#filter0_f_70_172_2)"
                  id="Ellipse 7188"
                  opacity="0.1"
                  style={{ mixBlendMode: "lighten" }}
                >
                  <ellipse
                    cx="624.819"
                    cy="527.354"
                    fill={primaryColor}
                    rx="218.819"
                    ry="121.354"
                  />
                </g>
                <defs>
                  <filter
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                    height="1054.26"
                    id="filter0_f_70_172_2"
                    width="1249.19"
                    x="0.223328"
                    y="0.223328"
                  >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                      in="SourceGraphic"
                      in2="BackgroundImageFix"
                      mode="normal"
                      result="shape"
                    />
                    <feGaussianBlur
                      result="effect1_foregroundBlur_70_172_2"
                      stdDeviation="202.888"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const IsErrorInitialState: { language: string | null; } = {
  language: null,
};
const WelcomeContent: React.FC<GameIntroType> = ({gameProgressData, preloadedAssets, setCurrentScreenId, currentScreenId, gameInfo, hasMulitLanguages, gameLanguages, profileData, setProfileData, isInitialLoadScreenWelcome, audioObj,setAudioObj,setIsInitialLoadScreenWelcome,setLearnerPlayingDetails,learnerPlayList,AssignId,setShowFloatingHub,showFloatingHub,setQuestState,setAssignId, UpdateLearnerData,setFeedbackList}) => {
  const { primaryColor } = useColor();
  const [isLanguageSelected, setIsLanguageSelected] = useState(false);
  const [isError, setIsError] = useState(IsErrorInitialState);
  const [loaded, setLoaded] = useState(false);
  const { learner_game_play_id } = useParams();
  const { profile, setProfile,isAssignmentError, setIsAssignmentError ,loadingProgress, setLoadingProgress} = useContext(ScoreContext);
  const [formState, setFormState] = useState<any>({
    language: 1 , //1 for english
  });
  //**************************************************** start New State for M4**************************************************************** */
  const user: any = JSON.parse(localStorage.getItem('user'));


 //****************************************************end New State for M4**************************************************************** */

  
 
  const navigate = useNavigate();
  
    const Handlemodel = async () => {

      //  play click sound
  try {
    const audio = new Audio(clickSound as string);
    audio.volume = 1;
    audio.play().catch(() => {});

    // ⏱stop after 2 seconds
    setTimeout(() => {
      audio.pause();
      audio.currentTime = 0;
    }, 2000);
  } catch (e) {
    // ignore audio errors
  }
  /**********************************Old code************************** */
//         const result = await getAssignedGame(learner_game_play_id);
//           if (
 
//   result?.message?.toLowerCase().includes("Invalid token")
// ) {
//    localStorage.removeItem("user");

//     navigate('/login')
//     return;
//   }
//         if(result?.status==="Success")
//         {
//           setAssignId(result?.LearnerPlayinggame?.gaId);
//           const learnerPlayingDetails = result?.LearnerPlayinggame?.learnerGameplayDetails ? JSON.parse(result?.LearnerPlayinggame?.learnerGameplayDetails):null;
//           if (!result?.LearnerPlayinggame?.learnerGameplayDetails) {
//                  const data = {
//                     learnerPlayList: learnerPlayList,
//                     gameProgressData:gameProgressData,
//                   };
//                   const dataString = JSON.stringify(data);
//                   const UpdateLearnerDetails = await updateLearnerDetails(dataString);
                    
//                 if(UpdateLearnerDetails?.data?.GetDetails?.learnerGameplayDetails){
//                   const responsedata:any = JSON.parse(UpdateLearnerDetails?.data?.GetDetails?.learnerGameplayDetails);
                    
//                     if(responsedata){
//                       setLearnerPlayingDetails(responsedata);
//                       setProfile(learnerPlayingDetails?.PlayerScore_Level);
//                       setQuestState(learnerPlayingDetails?.questState);
//                       setFeedbackList(learnerPlayingDetails?.feedbackList);
//                     }
//                 }
//                 if ((UpdateLearnerDetails as any)?.error === 'This game was Not assigned for this learner') {

//                       setIsAssignmentError(true); // ## Show popup by setting state to true
//                     setLoadingProgress(100);
//                     return; // ## Stop remaining code from executing
//                 }
//                 setLoadingProgress(100);
//                 setAudioObj((prev:any) => ({
//                   ...prev,
//                   Voicevolume: learnerPlayList?.audioVolumeValue?.voiceVolume ?? 0.5,
//                   BGMvolume: learnerPlayList?.audioVolumeValue?.bgmVolume ?? 0.5,
//                 }));

//           }
//          else
//             {
            
//             setLearnerPlayingDetails(learnerPlayingDetails);
//             setProfile(learnerPlayingDetails?.PlayerScore_Level);
//             setQuestState(learnerPlayingDetails?.questState);
//             setFeedbackList(learnerPlayingDetails?.feedbackList);
//             if(!learnerPlayingDetails?.player_gender || !learnerPlayingDetails?.selectedplayer_charcter || !learnerPlayingDetails?.mentor_gender || !learnerPlayingDetails?.selectedmentor_charcter){
//               setCurrentScreenId(1);
//               return false;
//             }else{
//               //    if(learnerPlayingDetails?.screenIdSeq.length !== 0)
//               // {
//               //   if (learnerPlayingDetails?.screenIdSeq[0] === 2) {
//                  setShowFloatingHub(true)
//                   // setCurrentScreenId(13);
//                   return;
//                 // }
//                 // else {
//                 //   // setCurrentScreenId(learnerPlayingDetails?.screenIdSeq[0]);
//                 //   setShowFloatingHub(true)
//                 //   // setCurrentScreenId(13);
//                 //   return;
//                 // }
              
//           }
//         } 
//         }

  
               
//                     setCurrentScreenId(1);
//                     return false;
        
  /**********************************New code*************************************/

    try {
      const result = await getAssignedGame(learner_game_play_id);

      if (result?.message?.toLowerCase().includes("Invalid token")) {
        localStorage.removeItem("user");

        navigate("/login");
        return;
      }

      if (result?.status === "Success") {
        setAssignId(result?.LearnerPlayinggame?.gaId);

        const learnerPlayingDetails =
          result?.LearnerPlayinggame?.learnerGameplayDetails
            ? JSON.parse(result?.LearnerPlayinggame?.learnerGameplayDetails)
            : null;

        if (!result?.LearnerPlayinggame?.learnerGameplayDetails) {
          const data = {
            learnerPlayList: learnerPlayList,
            gameProgressData: gameProgressData,
          };

          const dataString = JSON.stringify(data);

          // const UpdateLearnerDetails = await updateLearnerDetails(dataString);
          const UpdateLearnerDetails = await getupdateLearnerDetails(dataString);

          if (UpdateLearnerDetails?.data?.GetDetails?.learnerGameplayDetails) {
            const responsedata: any = JSON.parse(
              UpdateLearnerDetails?.data?.GetDetails?.learnerGameplayDetails
            );

            if (responsedata) {
              setLearnerPlayingDetails(responsedata);
              setProfile(responsedata?.PlayerScore_Level);
              setQuestState(responsedata?.questState);
              setFeedbackList(responsedata?.feedbackList);
              if (
                !responsedata?.player_gender ||
                !responsedata?.selectedplayer_charcter ||
                !responsedata?.mentor_gender ||
                !responsedata?.selectedmentor_charcter
              ) {
                setCurrentScreenId(1);
                return false;
              } else {
                setShowFloatingHub(true);
                return;
              }
            }
          }

          if (
            (UpdateLearnerDetails as any)?.error ===
            "This game was Not assigned for this learner"
          ) {
            setIsAssignmentError(true);
            setLoadingProgress(100);
            return;
          }

          setLoadingProgress(100);

          setAudioObj((prev: any) => ({
            ...prev,
            Voicevolume:
              learnerPlayList?.audioVolumeValue?.voiceVolume ?? 0.5,
            BGMvolume:
              learnerPlayList?.audioVolumeValue?.bgmVolume ?? 0.5,
          }));
        } else {
          setLearnerPlayingDetails(learnerPlayingDetails);
          setProfile(learnerPlayingDetails?.PlayerScore_Level);
          setQuestState(learnerPlayingDetails?.questState);
          setFeedbackList(learnerPlayingDetails?.feedbackList);

          if (
            !learnerPlayingDetails?.player_gender ||
            !learnerPlayingDetails?.selectedplayer_charcter ||
            !learnerPlayingDetails?.mentor_gender ||
            !learnerPlayingDetails?.selectedmentor_charcter
          ) {
            setCurrentScreenId(1);
            return false;
          } else {
            setShowFloatingHub(true);
            return;
          }
          
        }
      }

      setCurrentScreenId(1);
      return false;

    } catch (error) {
      console.error("Error in getAssignedGame:", error);

      // Handle unexpected errors
      setLoadingProgress(100);
      return false;
    }
  }
  
  const handleProfile = (e: any, input?: any) => {
    const { id, value } = e.target;
    if (id === 'language') {
      setIsLanguageSelected(false);
    }
    // Restrict the length of 'value' to a maximum of 15 characters if 'id' is 'name'
    const trimmedValue = id === 'name' ? value.slice(0, 15) : value;
    setIsError((prevError:any) => ({ ...prevError, [id]: null }));
    setFormState((prev: any) => ({ ...prev, [id]: id === 'name' ? trimmedValue : input }));
  };
  return (
    <>
     
    <div className="relative shrink-0 w-full">
      <div className="flex flex-col items-center relative size-full">
        <div className="box-border content-stretch flex flex-col gap-9 items-center justify-start pb-11 pt-[1.433rem] px-[1.433rem] relative w-full">
          <div className="text-white text-4xl font-normal text-center text-nowrap tracking-[0.005rem]">
           <p className="adjustLetterSpacing block leading-normal whitespace-normal text-center">
  Welcome to the Leadership Entry Activation Protocol
</p>

          </div>
          <div className="flex items-center justify-center relative shrink-0 w-full">
            <Buttons
              variant="ghost"
              size="sm"
              //  onClick={() => {
              //           Handlemodel();

              //         }}
              onClick={() => {
 
    Handlemodel();          // load data


}}

              // onClick={() => onNavigate?.("right")}
              className="w-[8.125rem] h-11 py-2 px-4 rounded-3xl transition-all duration-200 hover:scale-110 text-white hover:text-white font-rubik text-lg font-medium"
              style={{
                background: `linear-gradient(100deg ,
          rgba(${hexToRgb(
            primaryColor
          )}) -27.25%, rgba(0, 0, 0, 0.8) 107.803%)`,
                border: `1px solid rgba(${hexToRgb(primaryColor)}, 0.5)`,
                boxShadow: `0px 0px 21.786px 0px rgba(${hexToRgb(
                  primaryColor
                )}, 0.4)`,
              }}
            >
              Play
            </Buttons>
          </div>
        </div>
      </div>
    </div>
    
    </>
  );
};

const GameIntroScreenFutureTheme: React.FC<GameIntroType> = ({
  gameProgressData,
  setShowFloatingHub,
  showFloatingHub,
  audioObj,
  setAudioObj,
  preloadedAssets,
  setCurrentScreenId,
  currentScreenId,
  gameInfo,
  hasMulitLanguages,
  setReplayState,
  setReplayIsOpen,
  setQuestState,
  gameLanguages,
  isInitialLoadScreenWelcome,
  setIsInitialLoadScreenWelcome,
  profileData,
  setProfileData,
  learnerPlayList,
  setLearnerPlayingDetails,
  setAssignId,
  AssignId,
  UpdateLearnerData,
  setFeedbackList,
}) => {
  const [isQuestVideoReady, setIsQuestVideoReady] = useState(false);
  const { profile, setProfile,isAssignmentError, setIsAssignmentError ,loadingProgress, setLoadingProgress} = useContext(ScoreContext);
const navigationTimeoutRef = useRef<number | null>(null);

const handleQuestVideoEnd = () => {
  // Show the page for 3 seconds after video ends
  navigationTimeoutRef.current = window.setTimeout(() => {
    startPortalTransition(() => {
      setShowQuestHub(false);
      setCurrentScreenId(13);
    }, 5000); // transition animation time
  }, 3000); // ⏱ delay before navigation
};

  const { primaryColor } = useColor();
  const [isTransitioning, setIsTransitioning] = useState(false);
    // const [showFloatingHub, setShowFloatingHub] = useState(false);
    const [showQuestHub, setShowQuestHub] = useState(false);
      const floatingHubPreloadRef = useRef<HTMLVideoElement | null>(null);
  const questHubPreloadRef = useRef<HTMLVideoElement | null>(null);
    const [isFloatingReady, setIsFloatingReady] = useState(false);
    
  const videoRef = useRef<HTMLVideoElement | null>(null);
    const startPortalTransition = (
      actionAfterTransition: () => void,
      duration = 5000
    ) => {
      setIsTransitioning(true);

      setTimeout(() => {
        setIsTransitioning(false);
        actionAfterTransition();
      }, duration);
    };
    const refreshupdatelearnerdetails = async() =>{
      //   try {
      //   const data = {
      //     learnerPlayList: learnerPlayList,
      //     gameProgressData: gameProgressData,
      //   };

      //   const dataString = JSON.stringify(data);

      //   const UpdateLearnerDetails = await updateLearnerDetails(dataString);

      //     if (UpdateLearnerDetails?.data?.GetDetails?.learnerGameplayDetails) {
      //       const responsedata: any = JSON.parse(
      //         UpdateLearnerDetails?.data?.GetDetails?.learnerGameplayDetails
      //       );

      //       if (responsedata) {
      //         setLearnerPlayingDetails(responsedata);
      //         setProfile(responsedata?.PlayerScore_Level);
      //         setQuestState(responsedata?.questState);
      //         setFeedbackList(responsedata?.feedbackList);
      //         if (
      //           !responsedata?.player_gender ||
      //           !responsedata?.selectedplayer_charcter ||
      //           !responsedata?.mentor_gender ||
      //           !responsedata?.selectedmentor_charcter
      //         ) {
      //           setCurrentScreenId(1);
      //           return false;
      //         } 
      //       }
      //     }
      //   if (
      //     (UpdateLearnerDetails as any)?.error ===
      //     "This game was Not assigned for this learner"
      //   ) {
      //     console.error("failed");
      //     return; // ## Stop remaining code from executing
      //   }


      //   setAudioObj((prev:any) => ({
      //     ...prev,
      //     Voicevolume:
      //       learnerPlayList?.audioVolumeValue?.voiceVolume ?? 0.5,
      //     BGMvolume:
      //       learnerPlayList?.audioVolumeValue?.bgmVolume ?? 0.5,
      //   }));
      // } catch (error) {
      //   console.error("Error in UpdateLearnerData:", error);
      // }
     
      setShowFloatingHub(false);
      setIsQuestVideoReady(false);
      setShowQuestHub(true); // Move to Stage 2
    }
    const skipAllVideos = async() => {
      try {
        // Stop any playing video
        if (videoRef.current) {
          videoRef.current.pause();
          videoRef.current.currentTime = 0;
        }

        // Stop background audio
        if (audioObj) {
          audioObj.pause();
          audioObj.currentTime = 0;
        }

        stopAllAudio();
      } catch (e) {}

      // Reset states
      setShowFloatingHub(false);
      setShowQuestHub(false);
      setIsTransitioning(false);
      
      // Go directly to final screen
      setCurrentScreenId(13);
    };
  const stopAllAudio = () => {
  // Stop <audio> tags
  const audios = document.querySelectorAll('audio');
  audios.forEach((audio) => {
    audio.pause();
    audio.currentTime = 0;
  });

  // Stop WebAudio contexts (if used)
  if ((window as any).AudioContext || (window as any).webkitAudioContext) {
    try {
      const AudioCtx =
        (window as any).AudioContext || (window as any).webkitAudioContext;
      const ctx = new AudioCtx();
      ctx.suspend();
    } catch (e) {}
  }
};
useEffect(() => {
  if (showFloatingHub) {
    stopAllAudio();
  }
}, [showFloatingHub]);
useEffect(() => {
  if (showQuestHub) {
    stopAllAudio();
  }
}, [showQuestHub]);


const [floatingHubBlobUrl, setFloatingHubBlobUrl] = useState("");
const [questHubBlobUrl, setQuestHubBlobUrl] = useState("");

const inFlightFetchesRef = useRef<Set<string>>(new Set());

useEffect(() => {
  if (!preloadedAssets) {
   
    return;
  }

  const videosToCache = [
    {
      src: FloatingHub,
      setter: setFloatingHubBlobUrl,
      label: "FloatingHub",
    },
    {
      src: QuestHubVideo,
      setter: setQuestHubBlobUrl,
      label: "QuestHubVideo",
    },
  ];

  videosToCache.forEach(({ src, setter, label }) => {
    if (!src) {
      console.warn(`[VideoCache] ${label} source is missing`);
      return;
    }

    // Already cached
    if (window._videoBlobCache?.has(src)) {
      const cachedUrl = window._videoBlobCache.get(src);


      setter(cachedUrl);
      return;
    }

    // Already fetching
    if (inFlightFetchesRef.current.has(src)) {
    
      return;
    }

    inFlightFetchesRef.current.add(src);

   

    fetch(src)
      .then((res) => {
        if (!res.ok) {
          throw new Error(
            `${label} fetch failed: ${res.status} ${res.statusText}`
          );
        }

        return res.blob();
      })
      .then((blob) => {
        const blobUrl = URL.createObjectURL(blob);

        if (!window._videoBlobCache) {
          window._videoBlobCache = new Map();
        }

        window._videoBlobCache.set(src, blobUrl);

      

        setter(blobUrl);
      })
      .catch((err) => {
        console.error(`[VideoCache] ${label} failed:`, err);

        // Fallback to original URL
        setter(src);
      })
      .finally(() => {
        inFlightFetchesRef.current.delete(src);
      });
  });
}, [preloadedAssets]);

// const [floatingHubBlobUrl, setFloatingHubBlobUrl] = useState<string>(() => {
//   const src = preloadedAssets?.FloatingHub;
//   if (src && window._videoBlobCache?.has(src)) {
//     return window._videoBlobCache.get(src)!;
//   }
//   return '';
// });

// const [questHubBlobUrl, setQuestHubBlobUrl] = useState<string>(() => {
//   const src = preloadedAssets?.QuestHubVideo;
//   if (src && window._videoBlobCache?.has(src)) {
//     return window._videoBlobCache.get(src)!;
//   }
//   return '';
// });

// // 🔒 in-flight fetches ah track panrom — duplicate fetch வராம இருக்க
// const inFlightFetchesRef = useRef<Set<string>>(new Set());

// useEffect(() => {
//   const videosToCache: {
//     src: string | undefined;
//     setter: React.Dispatch<React.SetStateAction<string>>;
//     label: string;
//   }[] = [
//     { src: preloadedAssets?.FloatingHub, setter: setFloatingHubBlobUrl, label: 'FloatingHub' },
//     { src: preloadedAssets?.QuestHubVideo, setter: setQuestHubBlobUrl, label: 'QuestHubVideo' },
//   ];

//   videosToCache.forEach(({ src, setter, label }) => {
//     if (!src) {
//       console.warn(`[VideoCache] ${label} src ILLA`);
//       return;
//     }

//     // ✅ 1. Already cache la irundha, direct ah use pannunga
//     if (window._videoBlobCache && window._videoBlobCache.has(src)) {
    
//       setter(window._videoBlobCache.get(src)!);
//       return;
//     }

//     // ✅ 2. Already fetch NADAKKUDHUNA (in-flight), rendaam fetch start pannாதே
//     if (inFlightFetchesRef.current.has(src)) {
     
//       return;
//     }

//     // ✅ 3. Fetch start pannுrom, athை in-flight ah mark pannுrom
//     inFlightFetchesRef.current.add(src);
   
//     const fetchStartTime = performance.now();

//     const link = document.createElement('link');
//     link.rel = 'preload';
//     link.as = 'video';
//     link.href = src;
//     document.head.appendChild(link);

//     fetch(src)
//       .then((res) => res.blob())
//       .then((blob) => {
//         const blobUrl = URL.createObjectURL(blob);
//         if (!window._videoBlobCache) {
//           window._videoBlobCache = new Map();
//         }
//         window._videoBlobCache.set(src, blobUrl);
//         setter(blobUrl);

//         const timeTaken = ((performance.now() - fetchStartTime) / 1000).toFixed(2);
       
//       })
//       .catch((err) => {
//         console.error(`[VideoCache] ❌ ${label} fetch FAIL:`, err);
//         setter(src);
//       })
//       .finally(() => {
//         // fetch complete aana, in-flight la irundhு remove pannunga
//         inFlightFetchesRef.current.delete(src);
//       });
//   });
// }, [preloadedAssets?.FloatingHub, preloadedAssets?.QuestHubVideo]);

useEffect(() => {
  if (!showFloatingHub) return;

  const video = videoRef.current;

  if (!video) {
 
    return;
  }



  const playVideo = async () => {
    try {
      video.currentTime = 0;
      await video.play();
    
    } catch (error) {
      console.error("❌ FloatingHub video play failed:", error);
    }
  };

  if (video.readyState >= 2) {
    playVideo();
  }
}, [
  showFloatingHub,
  floatingHubBlobUrl,
  FloatingHub,
]);
//kishore hub video end
const playFloatingVideo = async () => {
  if (!videoRef.current) {
    console.warn("Floating video ref is null");
    return;
  }

  try {
    videoRef.current.currentTime = 0;

    await videoRef.current.play();


  } catch (error) {
    console.error("FloatingHub video play failed:", error);
  }
};
  return (
    <>
     {isTransitioning && (
          <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-black">
            <div
              className="hud-core hud-core-big"
           


            >
              <div className="hud-halo" />
              <div className="hud-ring hud-ring-outer" />
              <div className="hud-ring hud-ring-middle" />
              <div className="hud-ring hud-ring-inner" />
              <div className="hud-arc hud-arc-1" />
              <div className="hud-arc hud-arc-2" />
              <div className="hud-dot hud-dot-1" />
              <div className="hud-dot hud-dot-2" />
              <div className="hud-center" />
              <div className="hud-scan" />
            </div>
          </div>
        )}
     {showFloatingHub && (
        <div className="absolute transition-overlay">
          {/* <SkipButton onClick={skipAllVideos} /> */}
          {/* Floating Hub Video */}
        <video
        //  key={floatingHubBlobUrl || 'pending'}
        // ref={videoRef}
        // src={floatingHubBlobUrl}
        // muted={false}
        // autoPlay
        // playsInline
        // preload="auto"
        // className="transition-video"
        // style={{ visibility: showFloatingHub ? 'visible' : 'hidden' }}
        // onEnded={handleQuestVideoEnd}
         ref={videoRef}
  src={floatingHubBlobUrl || FloatingHub || ""}
  muted={false}
  playsInline
  preload="auto"
  className="transition-video"
  style={{
    visibility: showFloatingHub ? "visible" : "hidden",
  }}
  onLoadedData={() => {
  
  }}
  onCanPlay={() => {
   

    videoRef.current?.play().catch((err) => {
      console.error("FloatingHub play failed:", err);
    });
  }}
  onPlay={() => {
   
  }}
  onError={(e) => {
    console.error(
      "FloatingHub video error:",
      e.currentTarget.error
    );
  }}
  onEnded={handleQuestVideoEnd}
      />
          {/* //kishore hub video start */}
          <SkipButton onClick={skipAllVideos} />
          {/* Text */}
          <div className="transition-text">
            <div className="relative h-screen w-full overflow-hidden bg-cover bg-center bg-no-repeat">
              <div className="relative flex h-full w-full   px-4 sm:px-6 lg:px-8">
                {/* Dialogue Content */}
                <div className="flex h-full flex-grow flex-col items-center justify-end">
                  <div
                    className="relative flex h-full max-h-fit  w-full flex-col items-center justify-start rounded-2xl px-6 py-5"
                    style={{
                      background: `rgba(0,0,0,0.45)`, // blackish
                      backdropFilter: 'blur(30px)', // strong blur
                      border: `1px solid rgba(${hexToRgb(primaryColor)}, 0.35)`, // glowing border
                    }}
                  >
                    <div className="flex w-full max-w-screen-xl mx-auto items-start gap-6 sm:gap-8 lg:gap-10">
                      <div className="w-full">
                        <div className="relative">
                          <div className="pointer-events-none absolute -right-[5rem] -top-[5rem] h-[25rem] w-[30.75rem] opacity-20 mix-blend-exclusion">
                            <div
                              className="absolute inset-0 rounded-full blur-[21.875rem]"
                              style={{
                                background: primaryColor,
                              }}
                            />
                          </div>
                          <div className="pointer-events-none absolute -top-[7.5rem] left-10 h-[25rem] w-[30.75rem] opacity-15 mix-blend-exclusion">
                            <div
                              className="absolute inset-0 rounded-full blur-[21.875rem]"
                              style={{
                                background: primaryColor,
                              }}
                            />
                          </div>

                          <div className="relative z-10 w-full">
                            <div className="font-rubik flex flex-col text-justify text-[1.188rem] font-normal leading-[2rem] tracking-tight">
                              <div className="w-full">
                                <p className="block max-h-[134px] min-h-[6rem] cursor-pointer overflow-y-auto ps-1 text-white transition-all duration-300 hover:opacity-90">
                                  Welcome to NEO-ORBITAL LAB 7. The year is
                                  2050. Cars glide through the sky, and AI
                                  powers daily life. But one ambition remains
                                  out of reach: a humanoid AI built to help
                                  people live their best lives.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="absolute bottom-6 right-6 z-50 flex items-center">
                      <NavigationArrow
                        direction="right"
                        // onClick={() => setIsReplayPointDialogOpen(true)}
                        onClick={() => {
                          refreshupdatelearnerdetails()
                        }}
                      />
                    </div>

                    <div
                      className="pointer-events-none absolute inset-0 rounded-2xl"
                      style={{
                        boxShadow: `0px 0px 11px 0px inset rgba(${hexToRgb(
                          primaryColor,
                        )}, 0.3), 0px 0px 20px 0px rgba(${hexToRgb(
                          primaryColor,
                        )}, 0.2)`,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* //kishore hub video start */}
      {showQuestHub && (
        <div className="transition-overlay">
          {/* Quest Hub Video */}
           <SkipButton onClick={skipAllVideos} />
           <video
           key={questHubBlobUrl || 'quest-pending'}
        muted={false}
        src={questHubBlobUrl|| QuestHubVideo || ""}
        autoPlay
        playsInline
        preload="auto"
        className="transition-video"
        onCanPlay={() => setIsQuestVideoReady(true)}
        onEnded={handleQuestVideoEnd}
      />

      {/* //kishore hub video start */}
          {isQuestVideoReady && (
          <div className="transition-text">
            <div className="relative h-screen w-full overflow-hidden bg-cover bg-center bg-no-repeat">
              <div className="relative flex h-full w-full   px-4 sm:px-6 lg:px-8">
                {/* Dialogue Content */}
                <div className="flex h-full flex-grow flex-col items-center justify-end">
                  <div
                    className="relative flex h-full max-h-fit w-full flex-col items-center justify-start rounded-2xl px-6 py-5"
                    style={{
                      background: `rgba(0,0,0,0.45)`, // blackish
                      backdropFilter: 'blur(30px)', // strong blur
                      border: `1px solid rgba(${hexToRgb(primaryColor)}, 0.35)`,
                      minHeight:"10rem" // glowing border
                    }}
                  >
                    <div className="flex w-full max-w-screen-xl mx-auto items-start gap-6 sm:gap-8 lg:gap-10">
                      <div className="w-full">
                        <div className="relative">
                          <div className="pointer-events-none absolute -right-[5rem] -top-[5rem] h-[25rem] w-[30.75rem] opacity-20 mix-blend-exclusion">
                            <div
                              className="absolute inset-0 rounded-full blur-[21.875rem]"
                              style={{
                                background: primaryColor,
                              }}
                            />
                          </div>
                          <div className="pointer-events-none absolute -top-[7.5rem] left-10 h-[25rem] w-[30.75rem] opacity-15 mix-blend-exclusion">
                            <div
                              className="absolute inset-0 rounded-full blur-[21.875rem]"
                              style={{
                                background: primaryColor,
                              }}
                            />
                          </div>

                          <div className="relative z-10 w-full">
                            <div className="font-rubik flex flex-col text-justify text-[1.188rem] font-normal leading-[2rem] tracking-tight">
                              <div className="w-full">
                                <div className="transition-dark-overlay">
                                  <p className="block max-h-[134px] min-h-[6rem] cursor-pointer overflow-y-auto ps-1 text-white transition-all duration-300 hover:opacity-90">
                                    Humanity calls this dream Project ECHO, the
                                    world's boldest attempt to build a true AI
                                    teammate. And you’ve been chosen to lead it.
                                    Tensions are high, stakes even higher. The
                                    world is watching. Can you launch ECHO?
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="absolute bottom-6 right-6 z-50 flex items-center">
                      <NavigationArrow
                        direction="right"
                        onClick={() => {
                          setShowQuestHub(false);
                          // setCurrentScreenId(13); // Final screen
                           startPortalTransition(() => {
                              setCurrentScreenId(13);
                            }, 5000);
                        }}
                      />
                    </div>

                    <div
                      className="pointer-events-none absolute inset-0 rounded-2xl"
                      style={{
                        boxShadow: `0px 0px 11px 0px inset rgba(${hexToRgb(
                          primaryColor,
                        )}, 0.3), 0px 0px 20px 0px rgba(${hexToRgb(
                          primaryColor,
                        )}, 0.2)`,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          )}
        </div>
      )}
    <div
      className="relative w-full h-screen overflow-hidden bg-no-repeat bg-center bg-cover bg-black/90"
       style={{ backgroundImage: `url('${imgBackground}')` }}
    >
      {/* Main Content */}
      <div className="h-full flex-grow-1 flex flex-col justify-center items-center z-10 relative">
          <div className="animated-border-box-glow max-h-[34.5rem] max-w-[46rem]"></div>
          <div className="animated-border-box-glow-mirror max-h-[34.5rem] max-w-[46rem]"></div>
          <div className="animated-border-box max-h-[34.5rem] max-w-[46rem]">
        <div
          className="flex flex-col gap-5 max-h-[34.5rem] max-w-[46rem] overflow-hidden h-full w-full items-center justify-start rounded-[2.375rem] relative px-10 py-8 backdrop-filter backdrop-blur-[3.724rem]"
          style={{
            background: `linear-gradient(2deg, rgba(0, 0, 0, 0.70) -60.76%, rgba(${hexToRgb(
              primaryColor
            )}, 0.1) 147.18%)`,
            boxShadow: `0px 3.822px 47.777px 0px rgba(${primaryColor
              .replace("#", "")
              .match(/.{2}/g)
              ?.map((hex:any) => parseInt(hex, 16))
              .join(", ")}, 0.2), 0px 3.822px 3.822px 0px rgba(0,0,0,0.25)`,
          }}
        >
          <div className="absolute flex h-[50.669rem] items-center justify-center left-[-10.272rem] mix-blend-lighten top-[-5.541rem] w-[46.274rem]">
            <div className="flex-none rotate-[33.283deg]">
              <div className="h-[42.657rem] relative w-[27.352rem]">
                <div className="absolute bottom-[-59.453%] left-[-92.72%] right-[-92.72%] top-[-59.453%]">
                  <svg
                    className="block size-full"
                    fill="none"
                    preserveAspectRatio="none"
                    viewBox="0 0 1250 1495"
                  >
                    <g
                      filter="url(#filter0_f_70_170)"
                      id="Ellipse 7187"
                      opacity="0.1"
                      style={{ mixBlendMode: "lighten" }}
                    >
                      <ellipse
                        cx="624.819"
                        cy="747.26"
                        fill={primaryColor}
                        rx="218.819"
                        ry="341.26"
                      />
                    </g>
                    <defs>
                      <filter
                        colorInterpolationFilters="sRGB"
                        filterUnits="userSpaceOnUse"
                        height="1494.07"
                        id="filter0_f_70_170"
                        width="1249.19"
                        x="0.223328"
                        y="0.223328"
                      >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend
                          in="SourceGraphic"
                          in2="BackgroundImageFix"
                          mode="normal"
                          result="shape"
                        />
                        <feGaussianBlur
                          result="effect1_foregroundBlur_70_170"
                          stdDeviation="202.888"
                        />
                      </filter>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="basis-0 box-border content-stretch flex flex-col gap-3 grow items-start justify-start min-h-px min-w-px p-0 relative shrink-0 z-10">
            <AvatarAndTitle />
            <WelcomeContent
            showFloatingHub={showFloatingHub}
            setShowFloatingHub={setShowFloatingHub}
             audioObj={audioObj}
                       setAudioObj={setAudioObj}
  preloadedAssets={preloadedAssets}
  setCurrentScreenId={setCurrentScreenId}
  currentScreenId={currentScreenId}
  gameInfo={gameInfo.gameData}
  hasMulitLanguages={hasMulitLanguages}
  setReplayState={setReplayState}
  setReplayIsOpen={setReplayIsOpen}
  setQuestState={setQuestState}
  gameLanguages={gameLanguages}
  isInitialLoadScreenWelcome={isInitialLoadScreenWelcome}
  setIsInitialLoadScreenWelcome={setIsInitialLoadScreenWelcome}
  profileData={profileData}
  setProfileData={setProfileData}
  learnerPlayList={learnerPlayList}
  setLearnerPlayingDetails={setLearnerPlayingDetails}
  setAssignId={setAssignId}
  AssignId={AssignId}
  UpdateLearnerData={UpdateLearnerData}
  setFeedbackList={setFeedbackList}
  gameProgressData={gameProgressData}
/>

          </div>

          {/* Additional Background Effects */}
          <div className="absolute flex h-[36.624rem] items-center justify-center right-1/2 mix-blend-multiply top-[-23.769rem] w-[37.054rem]">
            <div className="flex-none rotate-[33.283deg]">
              <div className="h-[25.856rem] relative w-[27.352rem]">
                <div className="absolute bottom-[-98.086%] left-[-92.72%] right-[-92.72%] top-[-98.086%]">
                  <svg
                    className="block size-full"
                    fill="none"
                    preserveAspectRatio="none"
                    viewBox="0 0 1250 1226"
                  >
                    <g
                      filter="url(#filter0_f_70_168)"
                      id="Ellipse 7189"
                      opacity="0.2"
                      style={{ mixBlendMode: "darken" }}
                    >
                      <ellipse
                        cx="624.819"
                        cy="612.847"
                        fill={primaryColor}
                        rx="218.819"
                        ry="206.847"
                      />
                    </g>
                    <defs>
                      <filter
                        colorInterpolationFilters="sRGB"
                        filterUnits="userSpaceOnUse"
                        height="1225.25"
                        id="filter0_f_70_168"
                        width="1249.19"
                        x="0.223328"
                        y="0.223328"
                      >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend
                          in="SourceGraphic"
                          in2="BackgroundImageFix"
                          mode="normal"
                          result="shape"
                        />
                        <feGaussianBlur
                          result="effect1_foregroundBlur_70_168"
                          stdDeviation="202.888"
                        />
                      </filter>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div className="absolute flex h-[49.03rem] items-center justify-center left-1/2 mix-blend-darken top-[-9.411rem] w-[49.371rem]">
            <div className="flex-none rotate-[33.283deg]">
              <div className="h-[34.938rem] relative w-[36.124rem]">
                <div className="absolute bottom-[-72.588%] left-[-70.206%] right-[-70.206%] top-[-72.588%]">
                  <svg
                    className="block size-full"
                    fill="none"
                    preserveAspectRatio="none"
                    viewBox="0 0 1390 1371"
                  >
                    <g
                      filter="url(#filter0_f_70_166)"
                      id="Ellipse 7188"
                      opacity="0.3"
                      style={{ mixBlendMode: "overlay" }}
                    >
                      <ellipse
                        cx="694.991"
                        cy="685.505"
                        fill={primaryColor}
                        rx="288.991"
                        ry="279.505"
                      />
                    </g>
                    <defs>
                      <filter
                        colorInterpolationFilters="sRGB"
                        filterUnits="userSpaceOnUse"
                        height="1370.56"
                        id="filter0_f_70_166"
                        width="1389.54"
                        x="0.223328"
                        y="0.223328"
                      >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend
                          in="SourceGraphic"
                          in2="BackgroundImageFix"
                          mode="normal"
                          result="shape"
                        />
                        <feGaussianBlur
                          result="effect1_foregroundBlur_70_166"
                          stdDeviation="202.888"
                        />
                      </filter>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Card Border Effects */}
          <div className="absolute inset-0 pointer-events-none shadow-[1.911px_3.822px_15.289px_0px_inset_rgba(248,248,248,0.06)] rounded-[2.375rem]" />
          <div
            className="absolute inset-0 pointer-events-none rounded-[2.375rem]"
            style={{
              border: `1.911px solid rgba(${primaryColor
                .replace("#", "")
                .match(/.{2}/g)
                ?.map((hex:any) => parseInt(hex, 16))
                .join(", ")}, 0.1)`,

              boxShadow: `0px 3.822px 47.777px 0px rgba(${primaryColor
                .replace("#", "")
                .match(/.{2}/g)
                ?.map((hex:any) => parseInt(hex, 16))
                .join(", ")}, 0.2), 0px 3.822px 3.822px 0px rgba(0,0,0,0.25)`,
            }}
          />
        </div>
      </div>
        </div>

      {/* Bottom Decorative Elements */}
      <div className="absolute bottom-[-7.441%] left-[-1.128%] right-[-0.666%] top-[-5.352%]">
        <svg
          className="block size-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 1466 864"
        >
          <g id="Group 2085664301">
            <path d={svgPaths.p2b7f9200} fill="#033326" id="Vector" />
            <path d={svgPaths.p11193800} fill="#033326" id="Vector_2" />
            <path d={svgPaths.p2cfbdf00} fill="#033326" id="Vector_3" />
            <path d={svgPaths.p25915f40} fill="#033326" id="Vector_4" />
            <path d={svgPaths.p13d33080} fill="#033326" id="Vector_5" />
            <path d={svgPaths.p346b68f0} fill="#033326" id="Vector_6" />
            <path d={svgPaths.pfbc8300} fill="#033326" id="Vector_7" />
            <path d={svgPaths.p12946600} fill="#033326" id="Vector_8" />
            <path d={svgPaths.p2431d300} fill="#033326" id="Vector_9" />
            <path
              clipRule="evenodd"
              d={svgPaths.p37a93100}
              fill="#033326"
              fillRule="evenodd"
              id="Vector_10"
            />
            <path d={svgPaths.p10eaea00} fill="#033326" id="Vector_11" />
            <path d={svgPaths.p37932500} fill="#033326" id="Vector_12" />
            <path d={svgPaths.p223ae100} fill="#033326" id="Vector_13" />
            <path d={svgPaths.pdd17ff0} fill="#033326" id="Vector_14" />
            <path d={svgPaths.p3ec93e80} fill="#033326" id="Vector_15" />
            <path d={svgPaths.p181cbe80} fill="#033326" id="Vector_16" />
            <path d={svgPaths.p236a3580} fill="#033326" id="Vector_17" />
            <path d={svgPaths.p44d0500} fill="#033326" id="Vector_18" />
            <path d={svgPaths.p346d4700} fill="#033326" id="Vector_19" />
          </g>
        </svg>
      </div>
    </div>
    </>
  );
};

export default GameIntroScreenFutureTheme;


